const dateLocale = require('date-fns/locale/en');

export default {
  autocompleteTypes: ['(regions)'],
  dateLocale,
};
